import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarWrapper from "../layout/SidebarWrapper";
import Footer from "../layout/Footer";
import configureStore from "../../store/configureStore";
import RegisterFormCp from "./CpPages/RegisterFormCp";
import CpRegisteredUser from "./CpPages/CpRegisteredUser";
import { history } from "../../reducers";
import CommonSnackBar from "../common/CommonSnackBar";
import Header from "../layout/Header";

const store = configureStore();

class CpUserHome extends Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    console.log("componentDidMount  : ");
    if (!this.props.auth.isAuthenticated) {
      const path = window.location.pathname;
      history.push(`/login?redirect=${path}`);
      return;
    }
  }

  render() {
    const { permissions } = store.getState().permission;
    const { details } = store.getState().myProfile;

    return (
      <div className="page">
        <SidebarWrapper auth={this.props.auth} permissions={permissions} />
        <div className="container">
          <div className="HelpPageWrapper">
            {details.data.subscriptionStatus === "unsubscribed" &&
            details.data.defaultOrgType !== "SYSTEM" &&
            details.data.defaultOrgType !== "ROOT" ? (
              <RegisterFormCp userDetails={details} />
            ) : (
              <CpRegisteredUser userDetails={details} />
            )}
          </div>
        </div>

        <CommonSnackBar />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  permission: state.permission,
  myProfile: state.myProfile,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CpUserHome);
